import React, { useEffect, useState } from 'react';
import { Modal, Textarea } from '@mantine/core';
import { Button } from '../../../../../components/Button';
import classes from './wolt-order-panel.module.scss';

const MIN_REASON = 3;
const MAX_REASON = 200;

type WoltRejectModalProps = {
  opened: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
};

export const WoltRejectModal: React.FC<WoltRejectModalProps> = ({ opened, isSubmitting, onClose, onConfirm }) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (opened) {
      setReason('');
    }
  }, [opened]);

  const trimmed = reason.trim();
  const isValid = trimmed.length >= MIN_REASON && trimmed.length <= MAX_REASON;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="דחיית הזמנת וולט"
      centered
      radius="md"
      zIndex={302}
      closeButtonProps={{ 'data-testid': 'wolt-reject-close' } as Record<string, string>}
    >
      <div className={classes.modalBody} data-testid="wolt-reject-modal">
        <Textarea
          label="סיבת הדחייה (תוצג ללקוח)"
          value={reason}
          onChange={(event) => setReason(event.currentTarget.value.slice(0, MAX_REASON))}
          minRows={3}
          maxLength={MAX_REASON}
          required
          autosize
          data-testid="wolt-reject-reason"
        />
        <div className={classes.modalActions}>
          <Button variant="cancel" fullWidth onClick={onClose} disabled={isSubmitting} dataTestId="wolt-reject-cancel">
            ביטול
          </Button>
          <Button
            variant="confirm"
            fullWidth
            onClick={() => onConfirm(trimmed)}
            disabled={!isValid}
            loading={isSubmitting}
            dataTestId="wolt-reject-confirm"
          >
            דחה הזמנה
          </Button>
        </div>
      </div>
    </Modal>
  );
};
